import { render, staticRenderFns } from "./ChatSearchPanel.vue?vue&type=template&id=40d60aa6&scoped=true"
import script from "./ChatSearchPanel.vue?vue&type=script&lang=js"
export * from "./ChatSearchPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatSearchPanel.vue?vue&type=style&index=0&id=40d60aa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d60aa6",
  null
  
)

export default component.exports